export default __webpack_public_path__ + "static/media/chevron-down-green.e2085d70.svg";